/* "Barrel" of Http Interceptors */
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {CustomSiteContextInterceptor} from './custom-site-context.interceptor';
import {Provider} from '@angular/core';
import {HttpErrorHandler} from '@spartacus/core';
import {BadRequestHandler} from './handlers/bad-request.handler';
import {BadGatewayHandler} from './handlers/bad-gateway.handler';
import {ConflictHandler} from './handlers/conflict.handler';
import {ForbiddenHandler} from './handlers/forbidden.handler';
import {GatewayTimeoutHandler} from './handlers/gateway-timeout.handler';
import {InternalServerErrorHandler} from './handlers/internal-server-error.handler';
import {UnauthorizedErrorHandler} from './handlers/unauthorized.handler';
import {RefreshCartInterceptor} from './refresh-cart.interceptor';
import {DcpWithCredentialsInterceptor} from './dcp-with-credentials-interceptor';
import {BadVoucherRequestHandler} from '@app/http-interceptors/handlers/dcp-bad-voucher-request.handler';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders: Provider = [
  {provide: HTTP_INTERCEPTORS, useClass: CustomSiteContextInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: RefreshCartInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: DcpWithCredentialsInterceptor, multi: true},
  {provide: HttpErrorHandler, useExisting: BadRequestHandler, multi: true}, // 400
  {provide: HttpErrorHandler, useExisting: BadVoucherRequestHandler, multi: true}, // 400 vouchers application
  {provide: HttpErrorHandler, useExisting: UnauthorizedErrorHandler, multi: true}, // 401
  {provide: HttpErrorHandler, useExisting: ForbiddenHandler, multi: true}, // 403
  {provide: HttpErrorHandler, useExisting: ConflictHandler, multi: true}, // 409
  {provide: HttpErrorHandler, useExisting: InternalServerErrorHandler, multi: true}, // 500
  {provide: HttpErrorHandler, useExisting: BadGatewayHandler, multi: true}, // 502
  {provide: HttpErrorHandler, useExisting: GatewayTimeoutHandler, multi: true}, // 504
];
